import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AITransparency = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 py-12 px-6">
        <div className="container mx-auto max-w-4xl">
          <h1 className="font-heading text-4xl font-bold mb-8" data-testid="ai-transparency-title">AI Transparency Statement</h1>
          <div className="prose max-w-none space-y-6 text-muted-foreground">
            <p className="text-sm text-muted-foreground"><em>Last Updated: {new Date().toLocaleDateString()}</em></p>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">1. AI Model Usage</h2>
              <p>ScanMyAd uses the following AI technology:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li><strong>Model:</strong> OpenAI GPT-5.2</li>
                <li><strong>Purpose:</strong> Analyzing advertising content for compliance violations</li>
                <li><strong>Processing:</strong> Cloud-based via encrypted API calls</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">2. How AI Analysis Works</h2>
              <p>When you submit advertising content:</p>
              <ol className="list-decimal list-inside ml-4 space-y-2">
                <li>Your content is transmitted to OpenAI's API via TLS encryption</li>
                <li>GPT-5.2 analyzes text against regulatory frameworks and platform policies</li>
                <li>The model generates compliance risk assessments, violation detection, and suggested rewrites</li>
                <li>Results are returned to our platform and displayed in your report</li>
              </ol>
              <p className="mt-4"><strong>Data Retention:</strong> OpenAI does NOT store your content for model training (as per our API agreement).</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">3. AI Limitations & Risks</h2>
              <p>Users must understand the following limitations:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li><strong>Not Legal Advice:</strong> AI analysis does NOT constitute legal counsel</li>
                <li><strong>Accuracy Not Guaranteed:</strong> AI models can produce incorrect or incomplete analysis</li>
                <li><strong>Regulatory Evolution:</strong> Laws change; AI training data may be outdated</li>
                <li><strong>Jurisdictional Nuances:</strong> AI may miss region-specific interpretations</li>
                <li><strong>No Platform Approval:</strong> AI cannot predict platform moderation decisions</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">4. Human Review Recommendation</h2>
              <p className="font-semibold text-foreground">We STRONGLY RECOMMEND:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Review AI analysis with qualified legal counsel</li>
                <li>Validate suggested rewrites for business context</li>
                <li>Verify regulatory references with official sources</li>
                <li>Test ads in compliance with platform guidelines</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">5. AI Training & Updates</h2>
              <p>We do NOT use your submitted content to train AI models. OpenAI's GPT-5.2 is periodically updated by OpenAI (not by us). We monitor model performance and adjust prompts to improve accuracy.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">6. Accountability</h2>
              <p><strong>User Responsibility:</strong> You are solely responsible for final advertising decisions and compliance. ScanMyAd provides intelligence; YOU make the decision.</p>
              <p className="mt-4"><strong>Our Responsibility:</strong> We are responsible for maintaining service uptime, data security, and transparency about AI capabilities.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">7. EU AI Act Compliance</h2>
              <p>For EU users:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>ScanMyAd is a "limited risk" AI system under the EU AI Act</li>
                <li>We provide transparency disclosures as required</li>
                <li>Users must be informed they are interacting with AI</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">8. Contact for AI Concerns</h2>
              <p>For questions about AI usage:</p>
              <p className="mt-2">Email: support@scanmyad.com</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AITransparency;
